module.exports = __webpack_public_path__ + "static/img/card_1_2.721f267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/card_1_2.png
// module id = YN8P
// module chunks = 0